export enum Topic {
  NFL_TEAM = 'nfl.team',
  NFL_PLAYER = 'nfl.player',
  NFL_GAME = 'nfl.game',
  NFL_MISMATCH = 'nfl.mismatch',
  FOOTBALL_FANTASY = 'football.fantasy',
  FOOTBALL_BETTING = 'football.betting',
}
